import { render, staticRenderFns } from "./ObservacaoTarefa.vue?vue&type=template&id=782b63bc&"
import script from "./ObservacaoTarefa.vue?vue&type=script&lang=js&"
export * from "./ObservacaoTarefa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
